module.exports = require("./ng-file-upload.js");


/*****************
 ** WEBPACK FOOTER
 ** ng-file-upload (bower component)
 ** module id = 378
 ** module chunks = 1
 **/